module.exports = __webpack_public_path__ + "img/download_hero.68f907c.jpg";